import { AppModal } from "./modal.js";
import { APP } from "./app.js";
import { Utils } from "./utils.js";

export class MessageBus {
  static modal =
    new AppModal(
      document.querySelector("#info-modal"),
      document.querySelector("#alert-modal"),
      document.querySelector("#thanks-modal"),
    );

  // Resolves once the event is sent: a click that leaves the page waits for it
  static debug(message) {
    console.log(message, this.#callSite());
    return this.#sendDebugEvent(message);
  }

  // options.button labels the button that closes the modal
  static info(message, callback = null, options = {}) {
    console.log(message, this.#callSite());
    this.modal.info(message, callback, options);
    this.#sendDebugEvent(message);
  }

  static thanks(callback = null) {
    console.log("Thanks modal", this.#callSite());
    this.modal.thanks(callback);
  }

  static error(message, error = null) {
    console.error(message, error);

    try {
      const details = Utils.normalizeError(error);
      const summary = `${details.name}: ${details.message}`;

      // Kept on one line so marked passes the <details> block through as HTML
      const detailsBlock = `<details><summary>Details</summary><code>${Utils.escapeHtml(summary).replace(/\s*\n\s*/g, " ")}</code></details>`;

      this.modal.alert(`${message}\n\n${detailsBlock}`);
      this.#sendDebugEvent(`${message}\n\n${summary}\n${details.stack}`);
    } catch (handlerError) {
      console.error("MessageBus.error() failed", handlerError);
    }
  }

  // The line of the code that called debug/info/thanks, for the console only
  static #callSite() {
    try {
      return new Error().stack?.split("\n")[3]?.trim() ?? "";
    } catch (error) {
      return "";
    }
  }

  static #sendDebugEvent(message) {
    try {
      return APP.playcocolaAPI?.sendDebugEvent(message);
    } catch (error) {
      console.warn("Error sending DebugEvent", error);
    }
  }
}
